// removed by extract-text-webpack-plugin
module.exports = {"list-product-container":"list-product-container","product-left-filter":"product-left-filter","wrap-item":"wrap-item","list-title":"list-title","product-right-list":"product-right-list","btn-viewmore-product":"btn-viewmore-product","btn-viewmore-text":"btn-viewmore-text"};


//////////////////
// WEBPACK FOOTER
// ./components/list-product/style.scss
// module id = ./components/list-product/style.scss
// module chunks = 0